import { gql } from '@apollo/client';

export const LIST_ACTIVITY_STATUS = gql`
  query List {
    listActivityStatus {
      list {
        id
        name
      }
    }
  }
`;
